import React from 'react';
import Styled from 'styled-components';
import { fontQuicksand } from '../mixin';
import { device } from '../../../utils/responsive_utilities';

const CustomContainerB = () => {
  return (
    <>
      <SecureText>
        Secure payment. We use 256-bit encryption. The same that banks use
      </SecureText>
      <SecureText>
        *Taxes will be applicable as per the local tax laws.
      </SecureText>
    </>
  );
};

export const SecureText = Styled.p`
  color: #9294F6;
  margin: 0.2rem 0;
  ${fontQuicksand(1.2, 1.6)}
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1, 1.4)}
  }
  @media ${device.Phone} {
    ${fontQuicksand(1, 1.4)};
    margin-bottom: 1rem;
  }
  @media ${device.Tablet} and (orientation: portrait) {
    margin-bottom: 1rem;
  }
`;

export default CustomContainerB;
